<script>
import TitleImage from "@/components/molecules/title-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import { LayoutTypes } from "@/services/context/layout-helper";

export default {
  name: 'CategoriesList',
  components: { TitleImage, List, ListItem },
  props: {
    category: {
      type: Object,
      required: true
    }, 
    layout: {
      type: String,
      required: false,
      default: 'default'
    }
  },
  computed: {
    isMobile() {
      return this.layout === LayoutTypes.mobile;
    }
  }
};
</script>

<template>
  <div class="u-flex u-flex-wrap u-flex-justify-center">
    <List
      v-if="category.attributes.children"
      class="u-flex u-flex-wrap u-flex-justify-center"
    >
      <ListItem
        v-for="child in category.attributes.children.data"
        :key="`category-list-${child.id}`"
      >
        <TitleImage
          :label="child.attributes.libelle"
          :slug="child.attributes.slug"
          :image-path="child.attributes.visuel"
          :image-alt="child.attributes.libelle"
          :dimension="isMobile ? 120 : 90"
          radius="full"
          border
          class="u-m-sm"
        >
          {{ child.attributes.libelle }}
        </TitleImage>
      </ListItem>
    </List>
  </div>
</template>

<style lang="scss" scoped>
</style>
